module.exports = __webpack_public_path__ + "static/icons/icon-ski-hire-68f8ce2049e4572a6531958d40c6a446.svg";